import { FC } from "react";
import { Controller } from "react-hook-form";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import * as Yup from "yup";
import { Row, Col } from "antd";
import { useHandleForm } from "../../../hooks/useHandleForm";
import {
  FormBlock,
  FormField,
  FormInterval,
  IButton,
  ICheckbox,
} from "../../../ui-kit";
import smsSettings from "../../../store/smsSettings";
import { IIncidentItem } from "../SmsIncidentParams";

import styles from "../SmsSettings.module.scss";

const schema = Yup.object().shape({
  name: Yup.string().typeError("Введите тип инцидента"),
  buildingsOff: Yup.object({
    value: Yup.string().typeError("Введите количество зданий"),
  }),
  abonentsOff: Yup.object({
    value: Yup.string().typeError("Введите количество отключенных абонентов"),
  }),
  diameter: Yup.object({
    value: Yup.string().typeError("Введите диаметр"),
  }),
});

const SmsIncidentParamsForm: FC<{ record?: IIncidentItem }> = observer(
  ({ record }) => {
    const { incidentParamsFormIsSending } = smsSettings;
    const initialValues = {
      ...toJS(record),
    };
    const initialFocus = {};
    const {
      register,
      handleSubmit,
      watchAllField,
      isFocused,
      handleBlur,
      handleFocus,
      control,
      errors,
    } = useHandleForm(schema, initialValues, initialFocus);

    const onSubmit = (values) => {
      smsSettings.saveSmsIncidentParams(record.id, values);
    };

    return (
      <form
        className={styles.SmsSettingsParamsForm}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormBlock>
          <Row gutter={[15, 20]}>
            <Col span={16}>
              <FormField
                label="Тип инцидента"
                name="name"
                register={register}
                type="text"
                isFocused={isFocused.name}
                currentValue={watchAllField.name}
                onFocus={handleFocus}
                onBlur={handleBlur}
                error={errors?.name?.message}
                isRequired
              />
            </Col>
            <Col></Col>
            <Col span={24} className="form-block__data-header">
              <strong>Условия</strong>
            </Col>
          </Row>
          <Row gutter={[15, 20]}>
            <Col span={12}>
              <FormInterval
                className={styles.FormInterval}
                label="Количество зданий"
                name="buildingsOff"
                register={register}
                control={control}
                currentValue={watchAllField.buildingsOff}
                errors={errors}
                required
              />
            </Col>
          </Row>
          <Row gutter={[15, 20]}>
            <Col span={12}>
              <FormInterval
                className={styles.FormInterval}
                label="Количество отключенных абонентов"
                name="abonentsOff"
                register={register}
                control={control}
                currentValue={watchAllField.abonentsOff}
                errors={errors}
                required
              />
            </Col>
          </Row>
          <Row gutter={[15, 20]}>
            <Col span={12}>
              <FormInterval
                className={styles.FormInterval}
                label="Диаметр"
                name="diameter"
                register={register}
                control={control}
                currentValue={watchAllField.diameter}
                errors={errors}
                required
              />
            </Col>
          </Row>
          <Row gutter={[15, 20]}>
            <Col span={24}>
              <Controller
                control={control}
                name="useForMajorAccident"
                render={({ field: { value, onChange } }) => (
                  <ICheckbox
                    checked={value}
                    onChange={onChange}
                    label={"Использовать в фильтре"}
                  />
                )}
              />
            </Col>
            <Col span={24} className={styles.SmsSettingsFormButton}>
              <IButton disabled={incidentParamsFormIsSending.value}>
                Сохранить шаблон
              </IButton>
            </Col>
          </Row>
        </FormBlock>
      </form>
    );
  },
);

export default SmsIncidentParamsForm;
